module.exports = __webpack_public_path__ + "img/ic-analysis-line2.56751fcb.svg";